import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyDecimalNegativa]'
})
export class OnlyDecimalNegativaDirective {

  constructor() { }

  /**
   * keyCode's
   * 8: backspace
   * 109: signo -
   * 110: signo .
   */
  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || e.keyCode > 105) &&
      (e.keyCode != 8 && e.keyCode != 109 && e.keyCode != 110) 
    ) {
      e.preventDefault();
    }
  }
}
